
export default {
  props: {
    post: {
      type: Object,
      default: () => null,
    },
    content: {
      type: String,
      default: ``,
    },
    noDfp: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    showDfp () {
      // Show DFP within a single content block
      if (this.noDfp) {
        return false;
      }
      return this.getPageType(this.post) === `default` ? this.post?.acf?.dfp_options?.show_in_content : false;
    },
  },
};
